import { useContext } from 'react';
import CurrencyContext from '../contexts/CurrencyContext';

export default function useFormatMoney(amount, currency): string {
  const ctxCurrency = useContext(CurrencyContext);
  const { currency: _currency, convertPrice } = currency || ctxCurrency;

  return formatMoney(convertPrice(amount), _currency);
}

export function formatMoney(convertedPrice: number, currency: string): string {
  const limitedAmount = convertedPrice < 0 ? 0 : convertedPrice;

  if(window.GIFTBOX_CUSTOM_MONEY_FORMAT) {
    return window.GIFTBOX_CUSTOM_MONEY_FORMAT(limitedAmount, currency)
  }

  if (window.Intl && window.navigator) {
    return new Intl.NumberFormat(window.navigator.language, {
      style: 'currency',
      currency,
    }).format(limitedAmount);
  }

  return `${limitedAmount} ${currency}`;
}
